export default __webpack_public_path__ + "static/media/zaglushka.ab24974c.svg";